import { Down, Up } from "neetoicons";
import { Modal, Typography } from "neetoui";
import { prop } from "ramda";
import { useTranslation } from "react-i18next";

const ModalFooter = ({ enableAdvancedSearch }) => {
  const { t } = useTranslation();

  const shortcuts = [
    {
      label: t("neetoMolecules.finderModal.advancedSearch"),
      keys: ["Cmd/Ctrl", "Return"],
      isVisible: enableAdvancedSearch,
    },
    {
      label: t("neetoMolecules.common.actions.open"),
      keys: ["Return"],
      isVisible: true,
    },
    {
      label: t("neetoMolecules.common.actions.move"),
      keys: [
        <Up className="neeto-ui-text-gray-600" key="up" size={12} />,
        <Down className="neeto-ui-text-gray-600" key="down" size={12} />,
      ],
      isVisible: true,
    },
    {
      label: t("neetoMolecules.common.actions.close"),
      keys: ["Esc"],
      isVisible: true,
    },
  ];

  return (
    <Modal.Footer className="neeto-ui-border-gray-300 neeto-molecules-finder-modal__footer border-t px-6 py-4">
      <div className="neeto-ui-text-xxs flex items-center gap-4">
        {shortcuts.filter(prop("isVisible")).map(({ label, keys }, index) => (
          <div className="flex items-center gap-1" key={index}>
            <Typography
              className="neeto-ui-text-gray-600"
              component="span"
              style="nano"
            >
              {label}
            </Typography>
            {keys.map((key, index) => (
              <Typography
                className="neeto-ui-bg-gray-200 neeto-ui-rounded-sm neeto-ui-text-gray-600 px-1.5 py-1"
                component="span"
                key={index}
                style="nano"
              >
                {key}
              </Typography>
            ))}
          </div>
        ))}
      </div>
    </Modal.Footer>
  );
};

export default ModalFooter;
